const COLLAPSE_EVENT = 'collapse';

export { COLLAPSE_EVENT };
